(function($) {

	if ($('.jq-slider').length) {

		var sliderObserver = new IntersectionObserver(slidersInView, {
			rootMargin: '20% 0%'
		});

		$('.jq-slider').each(function() {
			if ($('.jq-slider-item', this).length > 1) sliderObserver.observe(this);
		});

		function slidersInView(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					if ('Splide' in window) {
						initSplide(entry.target);
					} else {
						$.getScript(siteConfig.path + 'js/libs/splide-2.4.20.min.js', function() {
							initSplide(entry.target);
						});
					}

					observer.unobserve(entry.target); // disable this line to turn on / off autoplay function by position in viewport
				} else {
					// TO-DO: stop autoplay slider if is not in viewport (optionally)
				}
			});
		}

		function initSplide(slider) {

			var $el = {
				slider: $(slider),
				stage: $('.jq-slider-stage', slider),
				items: $('.jq-slider-item', slider)
			};

			var cssClassPrefix = 'c-slider';

			$el.slider.addClass('splide');

			$el.stage.addClass('splide__list');

			$el.items.addClass('splide__slide');

			$el.stage.wrap('<div class="splide__track"></div>');

			var splideOptions = {
				type: 'loop',
				arrows: false,
				pagination: true,
				classes: {
					arrows: cssClassPrefix + '__navs',
					arrow: cssClassPrefix + '__button',
					prev: cssClassPrefix + '__prev',
					next: cssClassPrefix + '__next',
					pagination: cssClassPrefix + '__pagination',
					page: cssClassPrefix + '__pagination__button jq-slider-button',
				}
			};

			if ($el.slider.hasClass('jq-slider-simple')) {

				$el.slider.addClass(cssClassPrefix + '--simple');

			} else {

				splideOptions.arrows = true;

				splideOptions.arrowPath = 'M25.732 20L11.615 5.885l1.77-1.77L29.268 20 13.385 35.885l-1.77-1.77L25.732 20z';

				splideOptions.padding = {
					right: 'var(--splide-padding)',
					left : 'var(--splide-padding)',
				};

			}

			if (splideOptions.pagination) {

				$el.slider.addClass(cssClassPrefix + '--pagination');

			}

			var splideInstance = new Splide(slider, splideOptions);

			splideInstance.on('mounted', function () {

				$el.buttons = $('.jq-slider-button', $el.slider);

				$el.buttons.each(function(buttonKey) {

					var $slide = $el.items.eq(buttonKey);

					if ($slide.length == 0) return;

					if (typeof $slide.data('slider-item-thumb') === 'undefined') return;

					$(this).css('background-image', 'url(' + $slide.data('slider-item-thumb') + ')');

				});

			});

			splideInstance.on('pagination:updated', function(paginationElements, previousElement, currentElement) {

				var $pagination = $(paginationElements.list);

				var $button = $(currentElement.button);

				var buttonOffset = $button.offset().left;

				var buttonWidth = $button.width();

				var paginationCurrentScroll = $pagination.scrollLeft();

				var paginationWidth = $pagination.width();

				if (buttonOffset < paginationCurrentScroll ||
					buttonOffset + buttonWidth > paginationWidth) {

					$pagination.scrollLeft(
						paginationCurrentScroll +
						buttonOffset -
						paginationWidth / 2
					);

				}

			});

			splideInstance.mount();

			if (!('splideInstances' in window)) {

				window.splideInstances = [];

			}

			window.splideInstances.push(splideInstance);

		}

	}

})(jQuery);
